export default __webpack_public_path__ + "static/media/Ram.5850d704.png";